// extracted by mini-css-extract-plugin
export default {"bullet_item_wrapper":"style_bullet_item_wrapper__0Fazc","bullet_item":"style_bullet_item__yv-yb","check_icon":"style_check_icon__gaWyQ"};